import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "tick.icon",
  "use": "tick.icon-usage",
  "viewBox": "-13101.203 -12099.428 66.006 50.255",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-13101.203 -12099.428 66.006 50.255\" id=\"tick.icon\"><path d=\"M24.4,45.354,8.651,29.6,3.4,34.853l21,21,45-45L64.156,5.6Z\" transform=\"translate(-13104.604 -12105.027)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tick.icon.svg
// module id = fMbk
// module chunks = 13